// Dos franjas de un mismo dia se solapan si una empieza antes de que termine la otra.
// Franjas contiguas (10-12 y 12-14) no se solapan. Misma regla que App\Lib\CalendarTimePolicy en la API.
export function slotsOverlap(a, b) {
  if (!a || !b || a.from === "" || b.from === "" || a.to === "" || b.to === "") {
    return false;
  }
  return Number(a.from) < Number(b.to) && Number(b.from) < Number(a.to);
}

export function dayHasOverlap(hours) {
  return (hours || []).some((a, i) => hours.some((b, j) => j > i && slotsOverlap(a, b)));
}

export function availabilityHasOverlap(days) {
  return (days || []).some((day) => dayHasOverlap(day.hours));
}
